import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import "./CopyIcon.css";

const CopyIcon = ({ textToCopy }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    if (!textToCopy) return;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => console.error("Failed to copy text: ", err));
  };

  const renderTooltip = (props) => (
    <Tooltip id="copy-tooltip" {...props}>
      {isCopied ? "Copied!" : "Copy"}
    </Tooltip>
  );

  return (
    <div className="copy-icon-wrapper">
      <OverlayTrigger placement="top" overlay={renderTooltip}>
        <span onClick={handleCopy} style={{ cursor: "pointer" }}>
          {isCopied ? (
            <Check size={13} className="text-success" />
          ) : (
            <Copy size={13} className="text-primary" />
          )}
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default CopyIcon;
